import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=5ef8dc54&scoped=true"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=5ef8dc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef8dc54",
  null
  
)

export default component.exports